import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSnacksIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1406 24.3876L23.0332 4.58398",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6346 4.58513L13.9748 1.93703L11.5977 0.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5078 4.58398H24.2013",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.57 18.7225C17.7021 18.0717 16.4997 18.0717 15.6408 18.7225C14.9628 19.2287 14.1582 19.4998 13.3174 19.4998C12.4766 19.4998 11.6719 19.2287 11.0029 18.7225C10.135 18.0717 8.93258 18.0717 8.07371 18.7225C7.40469 19.2287 6.60007 19.4998 5.75928 19.4998C4.91848 19.4998 4.11386 19.2287 3.44484 18.7225C2.57693 18.0717 1.3745 18.0717 0.515625 18.7225",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.1931 6.67188H11.0681C14.9194 6.67188 18.0385 9.79033 18.0385 13.6409H1.22266C1.22266 9.79033 4.34173 6.67188 8.1931 6.67188Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 16.0645H18.5725",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.22266 21.4414H18.0385C18.0385 23.0684 16.7185 24.3881 15.0912 24.3881H4.17899C2.55165 24.3881 1.2317 23.0684 1.2317 21.4414H1.22266Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSnacksIcon;
